import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import Container from '../components/Container'
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import REACT_APP_API_BASE_URL from '../index.js';

const RegisterView = () => {
  const { configurations } = useContext(ConfigurationContext);
  const { 
    type,
    vehicle,
    getAnswers,
    configurationId,
  } = useContext(UserContext);
  const [state, setState] = useState({ error: false, redirect: false });
  if(!configurations) return <Redirect to='/'/>;
  if(state.redirect) return <Redirect to='/confirmation'/>;

  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const questions      = currentProduct.fields;

  const registration  = configurations.items.find( item => item.fordonstyp === 'registration' );

  const content  = configurations.items.find( item => item.fordonstyp === 'mail' );
  
  function handleSubmit(e) {
    e.preventDefault();

    const name  = document.getElementById('first_name').value + ' ' + document.getElementById('last_name').value;
    const tel   = document.getElementById('tel').value;
    const companyname   = document.getElementById('companyname').value;
    const mail  = document.getElementById('mail').value;
    const btn  = document.getElementById('formSubmit');

    let formData = {};
    let answers = [];

    getAnswers().map( (a, i) => {
      const newPropsObj = {
        id : a.id,
        answer : a.answer
      };
      answers[i] = newPropsObj;
    })

    formData.type              = type;
    formData.vehicle           = vehicle;
    formData.questions         = questions;
    formData.answers           = answers;
    formData.userdata     = { 
      name: name,
      tel: tel,
      companyname: companyname,
      mail: mail };
    formData.content           = content;

    btn.setAttribute('disabled', 'disabled');
    axios
    .post( REACT_APP_API_BASE_URL + '/send-confirmation', formData )
    .then(response => {
      if(response.status === 200) {
        setState( { ...state, redirect: true } )
      } else {
        btn.removeAttribute('disabled');
        setState( { ...state, error: true } )
      }
    })
    .catch( err => {
      btn.removeAttribute('disabled');
      setState( { ...state, error: true } )
    });
  }

  return (
    <Container>
      <div class="">
        <h1 class="text-3xl sm:text-5xl font-bold mb-10">{registration.title}</h1>

        <p class="text-base sm:text-xl mb-10">{registration.text}</p>
      </div>

      <form method="GET" onSubmit={ handleSubmit } action={'/form'} id={'configuration-form'}>
        <div>
          <input 
            type="text"
            id="first_name"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="Förnamn" 
            placeholder="Förnamn" />
        </div>

        <div>
          <input 
            type="text"
            id="last_name"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="Efternamn" 
            placeholder="Efternamn"
            required />
        </div>

        <div>
          <input
            type="text"
            id="tel"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="tel"
            placeholder="Telefon"
            required />
        </div>

        <div>
          <input
            type="text"
            id="companyname"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="companyname"
            placeholder="Företagsnamn"
            required />
        </div>

        <div>
          <input 
            // pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
            id="mail"
            className={'h-8 mb-4 pl-4 text-lg'}
            size="30"
            placeholder="E-post" 
            required />
        </div>

        { state.error === true ?
          <div class="error">
            Något gick fel med din beställning.
          </div>: null }
        
        <div class="flex justify-end mt-6">
          <input
            type="submit"
            value="Skicka förfrågan"
            id="formSubmit"
            className="px-8 py-3 bg-green text-2xl text-white font-medium rounded-tl-3xl rounded-br-3xl font-bold cursor-pointer" />
        </div>
      </form>



    </Container>
  );
};

export default RegisterView;
